/**
 * Chemins de l'espace consultant.
 *
 * Les composants n'assemblent jamais d'URL à la main : renommer une route se
 * fait ici, et TypeScript signale tous les appels à corriger.
 *
 * Chemins en français : ils sont visibles dans la barre d'adresse et font
 * partie de l'expérience produit.
 */
export const ROUTES = {
  settings: '/parametres',
  preferences: '/parametres/preferences',
  account: '/mon-compte',
  login: '/connexion',
  passwordReset: '/mot-de-passe-oublie',

  /**
   * L'accueil est la liste des CRA, et non un tableau de bord.
   *
   * Un consultant ouvre ce portail pour une raison et une seule : déclarer
   * son mois. Le déposer sur un écran de synthèse lui imposerait un clic
   * avant chaque usage réel.
   */
  timesheets: '/cra',
  timesheet: (id: string) => `/cra/${id}`,
  timesheetSatisfaction: (id: string) => `/cra/${id}/satisfaction`,

  missions: '/missions',
  mission: (id: string) => `/missions/${id}`,
  leaves: '/conges',

  /** Boîte de réception. En lecture seule : l'ESN écrit, le consultant lit. */
  messages: '/messages',
} as const;
